var Marionette = require('backbone.marionette');

var RelationTypeForm = require('./relationtype-form-view');
var RelationType = require('../../models/relation-type-model');
var DeleteConfirmationModal = require('../common/delete-confirmation-modal');
var DboTypesCollection = require('../../collections/dbotypes-collection');


var RelationTypeView = Marionette.View.extend({
    template: require('../../templates/relationtypes/relationtype.html'),
    regions:{
        relationTypeForm: '#relationtype-form',
        editSection: '#edit-section',
        deleteRelationTypeConfirmationModal: '.delete-confirmation-modal'
    },

    events:{
        'click #cancel-edit': 'backToList',
        'click #save-relationtype': 'saveChanges',
        'click #remove-relationtype': 'removeRelationType'
    },

    childViewEvents:{
        'delete:confirmed': 'deleteConfirmed'
    },

    initialize: function(){
        this.model = new RelationType();
        this.model.set('id', this.id);
        this.model.view = this;
        this.model.on('invalid', this.onErrors);
        _.bindAll(this, 'onRender', 'renderRelationType', 'backToList', 'saveChanges', 'removeRelationType');
        this.dboTypes = new DboTypesCollection();
        this.dboTypes.fetch({success: function() {
        }});
    },

    onErrors: function(model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function(){
        this.model.fetch({success: this.renderRelationType});
    },

    renderRelationType: function(){
        var that = this;
        that.relationTypeForm = new RelationTypeForm({model: that.model, dboTypes: that.dboTypes});
        that.showChildView('relationTypeForm', that.relationTypeForm);
        that.deleteRelationTypeConfirmationModal =
            new DeleteConfirmationModal({message: 'Enter: "confirm" if you agree to remove this relation type.',
                confirmationAnswer: 'confirm'});
        that.showChildView('deleteRelationTypeConfirmationModal', that.deleteRelationTypeConfirmationModal);
    },

    backToList: function(){
        Backbone.history.navigate('/relationtypes', {
            trigger: true
        });
    },

    saveChanges: function(){
        var that = this;
        that.model = that.relationTypeForm.fillModel();
        that.model.save(that.model.toJSON(), {success: function(response) {
            that.backToList();
        }
        });
    },

    removeRelationType: function(){
        this.$('#delete-confirmation-modal').modal();
    },

    deleteConfirmed: function(value) {
        if (value == true) {
            var that = this;
            this.model.destroy({
                dataType: "text",
                success: function() {
                    that.remove();
                    that.unbind();
                    that.backToList();
                }
            });
        }
    }

});

module.exports = RelationTypeView;


//////////////////
// WEBPACK FOOTER
// ./app/views/relationtypes/relationtype-view.js
// module id = 436
// module chunks = 0